module.exports = __webpack_public_path__ + "img/w矩形 85@3x.37d4e752.png";